import { Col, Row, Space, Typography } from "antd";
import {
  LLFormatWithTime,
  SimpleDateFormat,
} from "../../shared/helpers/DateFunctions";
import "./index.css";

const { Text } = Typography;
const OuthPrint = ({ data, consentDelta }) => {
  console.log("consent form details", data);
  return (
    <div className="justify-center">
      <div className="page">
        <main>
          <Space direction="vertical" size={20}>
            <header className="consent-header">
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  padding: "3px 8px",
                  marginBottom: 5,
                  background: "#f9f9f9",
                }}
              >
                <Row gutter={[8, 1]}>
                  <Col span={24}>
                    <Text style={{ fontSize: 10 }} strong>
                      MRN:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {data?.clientDetails?.mrn ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Name:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>{data?.name ?? "N/A"}</Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Father's Name:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>
                      {data?.fatherName ?? "N/A"}
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Age:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>{data?.age ?? "N/A"}</Text>
                  </Col>
                  <Col span={12}>
                    <Text style={{ fontSize: 10 }} strong>
                      Address:{" "}
                    </Text>
                    <Text style={{ fontSize: 10 }}>{data?.city ?? "N/A"}</Text>
                  </Col>
                </Row>
              </div>
            </header>
            <div>
              <span>
                I, <span className="fw-bold">{data?.name}</span> S/O{" "}
                <span className="fw-bold">{data?.fatherName}:</span>
              </span>
              <div
                ref={(el) => {
                  if (el) {
                    el.querySelectorAll(".ql-align-center").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "center",
                        "important",
                      );
                    });
                    el.querySelectorAll(".ql-align-right").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "right",
                        "important",
                      );
                    });
                    el.querySelectorAll(".ql-align-justify").forEach((item) => {
                      item.style.setProperty(
                        "text-align",
                        "justify",
                        "important",
                      );
                    });
                  }
                }}
                dangerouslySetInnerHTML={{ __html: data?.consent }}
                style={{ marginTop: 10 }}
              ></div>
              {/* <div>
                {consentDelta?.ops?.map((op, index) => (
                  <div index={index} className="mb-1">
                    <Typography.Text>{op?.insert}</Typography.Text>
                  </div>
                ))}
              </div> */}
            </div>
            <div className="flex-col">
              <span className="fw-bold">Please Sign:</span>
              <br />
              <br />
              <span className="fw-bold">Patient</span>
              <br />
              <br />
              <br />
              <br />
              <span className="fw-bold">Surgeon/Consultant</span>
              <br />
              <br />
              <br />
              <br />
              <Space>
                <span className="fw-bold">Date:</span>
                <span>{LLFormatWithTime()}</span>
              </Space>
            </div>
          </Space>
        </main>
        <footer></footer>
      </div>
    </div>
  );
};

export default OuthPrint;
